import classes from './fieldset.module.css'

const Fieldset = {
  classNames: {
    root: classes.root,
  },
}

export default Fieldset
